// extracted by mini-css-extract-plugin
module.exports = {"content":"hYLUCu","cardLink":"jAB7SD","name":"_0D0Fff","summary":"JcUWsP","shareButton":"ntU_3C","ctaLink":"b_6GQc"};